import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

/**
 * Overlay with some text information and loading optional animation
 */
@Component({
    selector: 'dialog-infooverlay',
    templateUrl: './info-overlay.component.html',
    styleUrls: [],
    standalone: false
})
export class InfoOverlayComponent {
  /**
   * extra css class for the body text
   */
  textclass = null;

  /**
   * If there should be a countdown visible, give the number of seconds here.
   */
  countdownSeconds: number = null;

  /**
   * an intervall object for the time countdown.
   */
  countDownInterval: any;

  seconds: string;
  minutes: string;

  /**
   * constructor
   * @param data
   */
  constructor(@Inject(MAT_DIALOG_DATA) public data: {title: string, body: string, animation: boolean, countdownSeconds: number}) {
    if(data.countdownSeconds != null && data.countdownSeconds > 0) {
      // init the countdown if we have data for it
      this.countdownSeconds = data.countdownSeconds;

      this.countDownInterval = setInterval(() => {
        this.countdownSeconds--;
        this.seconds = this.countdownSeconds % 60 < 10? "0" + (this.countdownSeconds % 60) : (this.countdownSeconds % 60) + "";
        this.minutes = "" + ((this.countdownSeconds - this.countdownSeconds % 60) / 60);

        if(this.countdownSeconds <= 0) {
          clearInterval(this.countDownInterval);
          this.countdownSeconds = 0;
        }
      }, 1000);
    }
  }

  /**
   * change the bodytext with a little animation.
   * @param body
   */
  public setNewBodytext(body: string): void {
    this.textclass = "flow";
    setTimeout(() => {
      this.data.body = body;

      setTimeout(() => {
        this.textclass = null;
      }, 500);
    }, 500);
  }
}
